import Vue from 'vue'

Vue.component('vue-single-product', {
  template: '#vue-single-product-template',
  props: ['product'],
  data() {
    return {
      backgroundImage: '',
    }
  },
  mounted() {
    this.backgroundImage = `url('${this.$props.product.image}')`
  },
})
